/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Complements as read; still carries the insurance history (read by the contractualisation).
 * @export
 * @interface CopropertyComplementsDto
 */
export interface CopropertyComplementsDto {
    /**
     * First premium of the current contract, excluding tax.
     * @type {number}
     * @memberof CopropertyComplementsDto
     */
    currentPremiumExclTax?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CopropertyComplementsDto
     */
    premiumYear?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CopropertyComplementsDto
     */
    deductibleGeneral?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CopropertyComplementsDto
     */
    deductibleFire?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CopropertyComplementsDto
     */
    deductibleTheft?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CopropertyComplementsDto
     */
    deductibleWaterDamage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CopropertyComplementsDto
     */
    deductibleVandalism?: number | null;
    /**
     * Forecast date of the next general meeting (follow-up statistics only).
     * @type {Date}
     * @memberof CopropertyComplementsDto
     */
    nextGeneralMeetingDate?: Date | null;
    /**
     * Insurance history — was the building insured over the last 36 months?
     * @type {boolean}
     * @memberof CopropertyComplementsDto
     */
    insuredLast36Months?: boolean | null;
    /**
     * Was the contract interrupted over the last 36 months?
     * @type {boolean}
     * @memberof CopropertyComplementsDto
     */
    coverageInterruptionLast36Months?: boolean | null;
    /**
     * Start of the interruption — required when coverageInterruptionLast36Months is true.
     * @type {Date}
     * @memberof CopropertyComplementsDto
     */
    coverageInterruptionStart?: Date | null;
    /**
     * End of the interruption — required when coverageInterruptionLast36Months is true.
     * @type {Date}
     * @memberof CopropertyComplementsDto
     */
    coverageInterruptionEnd?: Date | null;
    /**
     * Was the contract terminated over the last 36 months?
     * @type {boolean}
     * @memberof CopropertyComplementsDto
     */
    terminationLast36Months?: boolean | null;
    /**
     * Reason of the termination — required when terminationLast36Months is true.
     * @type {string}
     * @memberof CopropertyComplementsDto
     */
    terminationReason?: string | null;
}

/**
 * Check if a given object implements the CopropertyComplementsDto interface.
 */
export function instanceOfCopropertyComplementsDto(value: object): value is CopropertyComplementsDto {
    return true;
}

export function CopropertyComplementsDtoFromJSON(json: any): CopropertyComplementsDto {
    return CopropertyComplementsDtoFromJSONTyped(json, false);
}

export function CopropertyComplementsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopropertyComplementsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPremiumExclTax': json['currentPremiumExclTax'] == null ? undefined : json['currentPremiumExclTax'],
        'premiumYear': json['premiumYear'] == null ? undefined : json['premiumYear'],
        'deductibleGeneral': json['deductibleGeneral'] == null ? undefined : json['deductibleGeneral'],
        'deductibleFire': json['deductibleFire'] == null ? undefined : json['deductibleFire'],
        'deductibleTheft': json['deductibleTheft'] == null ? undefined : json['deductibleTheft'],
        'deductibleWaterDamage': json['deductibleWaterDamage'] == null ? undefined : json['deductibleWaterDamage'],
        'deductibleVandalism': json['deductibleVandalism'] == null ? undefined : json['deductibleVandalism'],
        'nextGeneralMeetingDate': json['nextGeneralMeetingDate'] == null ? undefined : (new Date(json['nextGeneralMeetingDate'])),
        'insuredLast36Months': json['insuredLast36Months'] == null ? undefined : json['insuredLast36Months'],
        'coverageInterruptionLast36Months': json['coverageInterruptionLast36Months'] == null ? undefined : json['coverageInterruptionLast36Months'],
        'coverageInterruptionStart': json['coverageInterruptionStart'] == null ? undefined : (new Date(json['coverageInterruptionStart'])),
        'coverageInterruptionEnd': json['coverageInterruptionEnd'] == null ? undefined : (new Date(json['coverageInterruptionEnd'])),
        'terminationLast36Months': json['terminationLast36Months'] == null ? undefined : json['terminationLast36Months'],
        'terminationReason': json['terminationReason'] == null ? undefined : json['terminationReason'],
    };
}

export function CopropertyComplementsDtoToJSON(json: any): CopropertyComplementsDto {
    return CopropertyComplementsDtoToJSONTyped(json, false);
}

export function CopropertyComplementsDtoToJSONTyped(value?: CopropertyComplementsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPremiumExclTax': value['currentPremiumExclTax'],
        'premiumYear': value['premiumYear'],
        'deductibleGeneral': value['deductibleGeneral'],
        'deductibleFire': value['deductibleFire'],
        'deductibleTheft': value['deductibleTheft'],
        'deductibleWaterDamage': value['deductibleWaterDamage'],
        'deductibleVandalism': value['deductibleVandalism'],
        'nextGeneralMeetingDate': value['nextGeneralMeetingDate'] == null ? undefined : ((value['nextGeneralMeetingDate'] as any).toISOString()),
        'insuredLast36Months': value['insuredLast36Months'],
        'coverageInterruptionLast36Months': value['coverageInterruptionLast36Months'],
        'coverageInterruptionStart': value['coverageInterruptionStart'] == null ? undefined : ((value['coverageInterruptionStart'] as any).toISOString()),
        'coverageInterruptionEnd': value['coverageInterruptionEnd'] == null ? undefined : ((value['coverageInterruptionEnd'] as any).toISOString()),
        'terminationLast36Months': value['terminationLast36Months'],
        'terminationReason': value['terminationReason'],
    };
}

